import { type ICartExperience } from 'types/cart';
import useListingV3 from 'api/listing/useListingV3/useListingV3';
import { ExperienceVersion } from '@kouto/types';
import useSupportedLanguage from 'utils/data/language/useSupportedLanguage';
import useCartItems from './useCartItems';

const useOneCartItemListing = (cartItemId: string) => {
  const { cartItems, isLoading: isLoadingCartItem } = useCartItems(true);
  const languageCode = useSupportedLanguage();

  const cartItem = cartItems[cartItemId] as ICartExperience | undefined;

  const { data: listing, isLoading: isLoadingListing } = useListingV3({
    listingId: cartItem?.listingId,
    skip: !cartItem?.listingId,
    version: ExperienceVersion.PUBLISHED,
    language: languageCode,
  });

  if (
    cartItem &&
    listing &&
    !cartItem.groupId &&
    cartItem.listingId &&
    cartItem.experienceId &&
    cartItem.experienceId !== cartItem.listingId
  ) {
    cartItem.groupId = listing.resourceGroups?.find((rg) =>
      rg.experiences.find((e) => e.id === cartItem?.experienceId),
    )?.id;
  }

  return {
    cartItem,
    listing,
    isLoading: isLoadingCartItem || isLoadingListing,
    isLoadingCartItem,
    isLoadingListing,
  };
};

export default useOneCartItemListing;
